import { createAction } from 'utils/redux'

export const setShouldSkipCampaigns = payload => createAction({
  type: 'SET_SHOULD_SKIP_CAMPAIGNS',
  payload
})

export const setShouldSkipWidgetTargeting = payload => createAction({
  type: 'SET_SHOULD_SKIP_WIDGET_TARGETING',
  payload
})

export const setShouldForceShowWidget = payload => createAction({
  type: 'SET_SHOULD_FORCE_SHOW_WIDGET',
  payload
})

export const updateOnlineStatus = payload => createAction({
  type: 'UPDATE_ONLINE_STATUS',
  payload
})

export const setHasExitIntent = () => createAction({
  type: 'SET_HAS_EXIT_INTENT'
})
